import React from "react";
import { Sparkle } from "lucide-react";

const words = [
  "PR",
  "Media",
  "Influencer Marketing",
  "Strategic Partnerships",
  "Brand Activations",
  "Product Launches",
  "Growth Marketing",
  "Lead Generation",
  "AI Consulting",
  "Branding",
  "Authority",
  "New York",
];

function Strip({ direction = "left" }) {
  const animClass =
    direction === "left" ? "animate-marquee" : "animate-marquee";
  return (
    <div className="flex w-max items-center gap-12" >
      {[...Array(2)].flatMap((_, copy) =>
        words.map((w, i) => (
          <div
            key={`${copy}-${i}`}
            className="flex items-center gap-12 shrink-0"
          >
            <span className="font-display text-5xl md:text-7xl lg:text-8xl font-light text-white/85 italic-none tracking-tight whitespace-nowrap">
              {w}
            </span>
            <Sparkle
              className="w-5 h-5 md:w-7 md:h-7 text-[#7FB3D5] shrink-0"
              fill="#7FB3D5"
              strokeWidth={0.8}
            />
          </div>
        ))
      )}
    </div>
  );
}

export default function Marquee() {
  return (
    <section
      data-testid="brand-marquee"
      className="relative bg-[#050505] border-y border-white/10 py-10 md:py-16 overflow-hidden"
      aria-label="What we do"
    >
      <div className="overflow-hidden">
        <div className="animate-marquee flex w-max">
          <Strip />
          <Strip />
        </div>
      </div>
      <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#050505] to-transparent pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#050505] to-transparent pointer-events-none" />
    </section>
  );
}
